'use client';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Link from '@/components/ui/Link';
import Button from '@/components/ui/Button';

export default function NotFound() {
    return (
        <div className="min-h-screen bg-background-tertiary flex flex-col justify-between">
            <Header />

            <main className="flex-1 w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px] py-16 sm:py-24 lg:py-32 flex items-center justify-center">
                <div className="max-w-2xl mx-auto bg-white rounded-2xl sm:rounded-3xl p-8 sm:p-12 lg:p-16 border border-border-light shadow-sm text-center flex flex-col items-center gap-6">
                    {/* Coming Soon Badge */}
                    <span className="px-4 py-1.5 rounded-full bg-primary-brand/10 text-primary-brand text-xs sm:text-sm font-bold tracking-widest uppercase">
                        EXCITING THINGS AHEAD
                    </span>

                    {/* Main Title */}
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary leading-tight">
                        Coming Soon!
                    </h1>

                    {/* Subtitle */}
                    <p className="text-base sm:text-lg lg:text-xl text-text-opacity-60 leading-relaxed max-w-lg">
                        We are working hard behind the scenes to launch this feature for you. Check back soon or explore our active collections!
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-4 w-full sm:w-auto justify-center">
                        <Link href="/shop" ariaLabel="Explore Shop">
                            <Button variant="primary" size="md" className="w-full sm:w-auto px-8 py-3.5 bg-primary-brand text-white font-semibold rounded-xl hover:bg-primary-brand-dark transition-all">
                                Explore Shop
                            </Button>
                        </Link>
                        <Link href="/" ariaLabel="Back to Home">
                            <button className="w-full sm:w-auto px-8 py-3.5 border border-border-light text-text-primary font-semibold rounded-xl hover:bg-background-tertiary transition-all">
                                Back to Home
                            </button>
                        </Link>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
